export const HOLDS_COLUMNS_PRINT = [
  {
    label: "Address Line",
    field: "home.address.addressLine1",
    width: 150,
  },
  {
    label: "City",
    field: "home.address.city",
    width: 90,
  },
  {
    label: "Builder",
    field: "home.builderName",
    width: 120,
  },
  {
    label: "Community Name",
    field: "home.communityName",
    width: 130,
  },
  {
    label: "Due Date",
    field: "assignment.workOrder.hardDueDate",
    width: 85,
  },
  {
    label: "Hold Date",
    field: "assignment.workOrder.holdStartDate",
    width: 85,
  },
  {
    label: "Work Order",
    field: "assignment.workOrder.abbreviation",
    width: 95,
  },
  {
    label: "Order",
    field: "assignment.assignmentTemplateShortName",
    width: 80,
  },
  {
    label: "Assignment",
    field: "assignedUserName",
    width: 200,
  },
];
